import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
// import ServicesBox from "../../Component/ServiceCMPT/ServicesBox";
// import { getServices } from "../../Utils/servicesApi";
import { Helmet } from "react-helmet";

export default function Services() {


  return (
    <>
      <Helmet>
        <title>Services - Bhadorva Infra</title>
        <meta
          name="description"
          content="At Bhadorva Infra, we bring over 15 years of expertise in real estate, specializing in luxury bungalows, premium plotting, and high-quality construction. Our commitment lies in shaping developments that reflect elegance, comfort, and timeless luxury, setting new benchmarks in modern living."
        />
        <meta
          name="keywords"
          content="Bhadorva Infra,real estate,specializing in luxury bungalows, premium plotting, high-quality construction"
        />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb pagename="Services" mainpage="" />
      <section className="service-section-3 fix section-padding">
        <div className="container">
          <div className="row">
            {/* {services.length > 0
              ? services.map((service, index) => (
                  <ServicesBox key={index} serviceData={service} />
                ))
              : ""} */}
          </div>
        </div>
      </section>
    </>
  );
}
